import { render } from "./orders.vue?vue&type=template&id=3aab9cc1&scoped=true&ts=true"
import script from "./orders.vue?vue&type=script&lang=ts"
export * from "./orders.vue?vue&type=script&lang=ts"

import "./orders.vue?vue&type=style&index=0&id=3aab9cc1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aab9cc1"]])

export default __exports__